import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

export const Specifications = styled(Grid)`
  width: auto;
`;

export const SpecificationView = styled(Box)`
  ${({ theme: { breakpoints, colors } }) => `
    position: relative;
    width: 110px;
    height: 65px;
    cursor: pointer;
    margin: 0 10px 10px 0;
    background-color: ${colors.greys.greys2};

    ${breakpoints.up('sm')} {
      width: 175px;
      height: 105px;
    }
  `};
`;
